<template>
    <!-- {{ outstandingMatriceEndDate || "outstandingMatriceEndDate undefined"}}
    {{ allThirdPartyCompanies?.length }}
    {{ thirdPartyCompanies?.length }}
    {{ filteredThirdPartyCompanies?.length }}
    {{ search }}
    {{ mode }}
    {{ otherUserAccessAlowed }}
    {{ selectedManager }}
    {{ companyUsers?.length }} -->
    <v-container fluid>
        <v-row no-gutters class="pb-2">
            <!-- <v-col cols="2" class="pl-2">
                <v-text-field
                    dense
                    readonly
                    outlined
                    :model-value="getUserDisplayName(selectedUser)"
                    @click="openUserDialog"
                >
                </v-text-field>
            </v-col> -->
            <v-col cols="2" v-if="!!sepaAccountableAccount">
                <v-btn-primary block @click="payDialog = true">{{ sepaTitle }}</v-btn-primary>
            </v-col>
            <v-col cols="2" class="pl-2" v-if="otherUserAccessAlowed && selectedManager">
                <v-select
                    outlined
                    v-model="selectedManager"
                    :items="companyUsers"
                    :item-title="getUserDisplayName"
                    required
                    hide-details="auto"
                    label="Responsables"
                    return-object
                    density="compact"
                />
            </v-col>
            <!-- <v-col cols="2" class="pl-2">
                <v-select outlined
                    v-model="selectedManager"
                    :items="accountingFirmClientManagers"
                    item-text="key"
                    item-value="id"
                    required
                    dense
                    hide-details="auto"
                    label="Responsables"
                ></v-select>
            </v-col> -->
            <v-col cols="2" class="pl-2">
                <v-select
                    outlined
                    v-model="selectedTagIds"
                    :items="thirdPartyCompanyTags"
                    item-value="id"
                    required
                    hide-details="auto"
                    label="&#xc9;tiquettes"
                    multiple
                    density="compact"
                    :item-title="(item) => item.key"
                />
            </v-col>
            <!-- <v-col cols="4" class="pl-2">
                <OssAccountingPeriodSelector
                    v-model="accountingPeriod"
                    :global="false"
                    :companyId="companyId"
                    hide-details
                    dense
                ></OssAccountingPeriodSelector>
            </v-col> -->
            <v-col cols="2" class="pl-2">
                <v-select
                    v-model="endDate"
                    :items="endMonthlyDates"
                    label="Date de fin"
                    elevation="0"
                    outlined
                    hide-details
                    density="compact"
                />
            </v-col>
            <v-col cols="2" class="pl-2">
                <v-text-field
                    outlined
                    v-model="search"
                    hide-details
                    label="Recherche..."
                    type="text"
                    block
                    density="compact"
                    @click:clear="search = ''"
                    clearable
                    append-inner-icon="$search"
                >
                </v-text-field>
            </v-col>
            <v-col cols="1" v-if="!$vuetify.display.mobile" class="pl-2">
                <TutorialButtonDialog :starterComponents="'Outstanding;'"> </TutorialButtonDialog>
            </v-col>
        </v-row>

        <template v-if="isAuthorized">
            <v-tabs v-model="step" fixed-tabs style="border-radius: 16px; overflow: hidden">
                <v-tab value="0" href="#0"> <strong>Encours</strong></v-tab>
                <v-tab value="1" href="#1" v-if="!!checkReceivablesAgeingKey">
                    <strong>Échéancier</strong></v-tab
                >
                <v-tab value="2" href="#2" v-if="mode === 'client'">
                    <strong>Matrice Factures</strong></v-tab
                >
                <!-- <v-tab
                    value="paymentLinks"
                    href="#paymentLinks"
                    v-if="paymentLinks && paymentLinks.length"
                >
                    <strong>{{ $t("openPoints.category.payments") }}</strong></v-tab
                > -->
            </v-tabs>
            <v-tabs-window v-model="step">
                <v-window-item value="0">
                    <OpenPoints
                        :mode="openPointsMode"
                        :userId="
                            selectedManager && selectedManager.user ? selectedManager.user.id : ''
                        "
                        :filteredThirdPartyCompanies="filteredThirdPartyCompanies"
                    >
                    </OpenPoints>
                </v-window-item>
                <v-window-item value="1" v-if="!!checkReceivablesAgeingKey">
                    <CheckReceivablesAgeing
                        :mode="'Embedded'"
                        :companyId="companyId"
                        :inFilteredThirdPartyCompanies="filteredThirdPartyCompanies"
                        :accountingPeriodId="accountingPeriod.id"
                        :acKey="checkReceivablesAgeingKey"
                        :inSelectedDate="receivableAgeingDate"
                        :showBarchart="true"
                        v-if="accountingPeriod && accountingPeriod.id"
                    />
                </v-window-item>
                <v-window-item value="2" v-if="mode === 'client'">
                    <OutstandingMatrice
                        :companyId="companyId"
                        :clients="filteredThirdPartyCompanies"
                        :startDate="startDate"
                        :endDate="outstandingMatriceEndDate"
                        v-if="startDate"
                    />
                </v-window-item>
                <v-window-item value="paymentLinks">
                    <v-row class="pt-1">
                        <v-col>
                            <v-data-table
                                :hide-default-header="true"
                                :items="paymentLinks"
                                :items-per-page="-1"
                                hide-default-footer
                                density="compact"
                                class="table"
                            >
                                <template v-slot:item="props">
                                    <tr
                                        style="background-color: #fff"
                                        :key="props.item.id"
                                        @click.stop="props.item.showDetail = !props.item.showDetail"
                                    >
                                        <td class="text-center">
                                            <v-icon v-if="1 === 2">{{
                                                props.item.showDetail
                                                    ? "$fa-chevron-up"
                                                    : "$fa-chevron-down"
                                            }}</v-icon>
                                        </td>
                                        <td class="text-left">
                                            <div>
                                                <strong>{{ props.item.label }}</strong>
                                            </div>
                                        </td>
                                        <td class="text-right">
                                            {{ formattedDate(props.item.created_at) }}
                                        </td>
                                        <td class="text-right">
                                            <strong>{{
                                                props.item.amount
                                                    ? newCommonFormatCurrency(props.item.amount)
                                                    : "-"
                                            }}</strong>
                                        </td>
                                        <td class="text-right">
                                            <div>
                                                <strong>{{
                                                    formatStatus(props.item.status)
                                                }}</strong>
                                            </div>
                                        </td>
                                        <td class="text-right">
                                            <div
                                                v-if="props.item.revoked_at"
                                                style="font-style: italic; font-size: x-small"
                                            >
                                                {{
                                                    "EXPIRÉ le " +
                                                    formattedDate(props.item.revoked_at)
                                                }}
                                            </div>
                                            <v-btn-trash
                                                v-else
                                                @click="openDeletePaymentLinkDialog(props.item)"
                                                v-tooltip="'Faire expirer ce lien'"
                                                size="small"
                                            />
                                        </td>
                                    </tr>
                                    <tr v-show="props.item.showDetail && 1 === 2">
                                        <td
                                            colspan="4"
                                            style="padding: 0; background: #f4f4f4"
                                            class="py-2 px-0"
                                        >
                                            <!-- <AccountableAccountBalanceDetailOpenPoints
                                        :companyId="companyId"
                                        :accountingPeriodId="accountingPeriodId"
                                        :mode="mode"
                                        :accountableAccountInfo="props.item"
                                        :inAccountingTransactions="props.item.accountingTransactions"
                                        :notReconciliated="true"
                                        v-if="props.item.activateDetail"
                                        v-show="props.item.showDetail"
                                        @bankTransactionSelected="onBankTransactionSelected($event)"
                                        @refresh="refresh"
                                        >
                                    </AccountableAccountBalanceDetailOpenPoints> -->
                                        </td>
                                    </tr>
                                </template>
                                <template
                                    v-slot:body.append
                                    v-if="paymentLinks && paymentLinks.length > 1"
                                >
                                    <td class="text-center" />
                                    <td class="text-left" />
                                    <td class="text-right"><strong /></td>
                                    <td class="text-right">
                                        <div>
                                            <strong>
                                                {{ paymentLinks.length }}
                                                liens de paiements générés</strong
                                            >
                                        </div>
                                    </td>
                                    <td class="text-left" />
                                    <td class="text-left" />
                                </template>
                            </v-data-table>
                        </v-col>
                    </v-row>
                </v-window-item>
            </v-tabs-window>
        </template>
        <SepaAuto
            v-model="payDialog"
            :companyId="companyId"
            :filteredThirdPartyCompanies="filteredThirdPartyCompanies"
            :accountableAccount="sepaAccountableAccount"
            @actionDone="refresh()"
            v-if="payDialog"
        />
        <oss-dialog
            v-model="deletePaymentLinkDialog"
            :title="'Suppresion du lien de paiement'"
            @valid="deletePaymentLink()"
            :validLoading="deletePaymentLinkLoading"
            width="800px"
        >
            <div class="d-flex justify-center">
                &#xca;tes-vous sûr(e) de vouloir supprimer le lien de paiement ?
            </div>
            <div class="d-flex justify-center">
                (le lien deviendra obsolète pour votre client, qui ne pourra plus payer avec)
            </div>
        </oss-dialog>
        <!-- <oss-dialog
            v-model="userDialog"
            :title="'Collaborateur'"
            max-width="800px"
        >
            <template v-slot:content>
                <select-user
                    class="px-1"
                    v-model="selectedUser"
                    :companyId="companyId"
                    :type="'NATURAL_PERSON'"
                    :withEmail="true"
                    :outstanding="'client'"
                    @user-selected="userDialog=false"
                ></select-user>
            </template>
        </oss-dialog> -->
    </v-container>
</template>
<script lang="ts">
import { User } from "../../store/store";
import { Apollo } from "@/decorators";
import moment from "moment-timezone";
import _ from "lodash";

import COMPANY_USERS from "../../graphql/user/CompanyUsers.gql";
import CUSTOMER_COMPANIES from "../../graphql/company/CustomerCompanies.gql";
import SUPPLIER_COMPANIES from "../../graphql/company/SupplierCompanies.gql";
// import ACCOUNTING_FIRM_CLIENT_MANAGERS from "../../graphql/billing/AccountingFirmClientManagers.gql";
import THIRDPARTYCOMPANY_TAGS_QUERY from "../../graphql/tag/ThirdPartyCompanyTags.gql";
import GET_PAYMENT_LINKS from "../../graphql/paymentLinks/GetPaymentLinks.gql";
import DELETE_PAYMENT_LINK from "../../graphql/paymentLinks/DeletePaymentLink.gql";

// import SelectUser from "../user/SelectUser.vue";
// import OssAccountingPeriodSelector from "../ossComponents/ossAccountingPeriodSelector.vue"
import GeneralLedger2 from "../GeneralLedger2.vue";
import OutstandingMatrice from "./OutstandingMatrice.vue";
import OpenPoints from "../dashboardAccounting/OpenPoints.vue";
import CheckReceivablesAgeing from "../audit/CheckReceivablesAgeing.vue";
import SepaAuto from "../pay/SepaAuto.vue";

import { getAccountingPeriodEndMonths } from "../../services/accountingPeriods";
import { getUserDisplayName } from "../../services/userServices";
import { newCommonFormatCurrency } from "../../../../backend/src/common/services/mathServices";
// import ThirdPartyCompanies from '../ThirdPartyCompanies.vue';
import TutorialButtonDialog from "../tutorial/TutorialButtonDialog.vue";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";
import { Watch } from "vue-facing-decorator";

@Component({
    components: {
        // SelectUser,
        // OssAccountingPeriodSelector,
        GeneralLedger2,
        OutstandingMatrice,
        OpenPoints,
        CheckReceivablesAgeing,
        SepaAuto,
        TutorialButtonDialog,
    },
})
export class Outstanding extends Vue {
    @Prop({ default: "client" }) mode: "client" | "supplier";

    step = "0";

    selectedManager = null;

    // get selectedManager() {
    //     let selectedManager = this.vSelectSelectedManager;
    //     if (!selectedManager) {
    //         selectedManager = this.companyUsers.find((cu) => cu.user?.id === this.currentUser.id);
    //     }
    //     return selectedManager;
    // }

    // set selectedManager(value) {
    //     this.vSelectSelectedManager = value;
    // }

    selectedTagIds = [];

    endDate = "";
    receivableAgeingDate = moment().format("YYYY-MM-DD");
    search = "";

    payDialog: boolean = false;

    get openPointsMode() {
        return "outstanding" + (this.mode === "client" ? "Client" : "Supplier");
    }

    get sepaTitle() {
        if (this.mode === "client") {
            return "Prélèvement";
        }
        if (this.mode === "supplier") {
            return "Virement";
        }
        return "";
    }

    get sepaAccountableAccount() {
        if (this.mode === "client") {
            return "411000";
        }
        if (this.mode === "supplier") {
            return "401000";
        }
        return "";
    }

    get checkReceivablesAgeingKey() {
        if (this.mode === "client") {
            return "E0203ayUPxB5dyvLb0OovyHY";
        }
        if (this.mode === "supplier") {
            return "RAL6Y74cKESdNskvPy5zb2mDX";
        }
        return "";
    }

    get accountingPeriod() {
        return this.$store.state.accountingPeriod?.selectedAccountingPeriod;
    }

    getUserDisplayName(companyUser) {
        return getUserDisplayName(companyUser.user);
    }

    get currentUser(): User {
        return this.$store.state.user;
    }

    get isAccountingEmployee() {
        return this.currentUser.isAccountingEmployee;
    }

    get otherUserAccessAlowed() {
        return this.currentUser.profile?.configuration?.outstanding?.otherUserAccess;
    }

    get selectedCompany() {
        return this.$store.state.selected_company;
    }

    get companyId() {
        return this.selectedCompany?.id || "";
        // return this.currentUser.company.id || ""
    }

    get startDate() {
        return this.accountingPeriod?.start; // moment(this.accountingPeriod.start).format('YYYY-MM-DD')
    }

    get endMonthlyDates() {
        return getAccountingPeriodEndMonths(this.accountingPeriod);
    }

    get outstandingMatriceEndDate() {
        if (this.endDate) {
            return this.endDate;
        }
        if (this.accountingPeriod?.end) {
            return this.accountingPeriod.end;
        }
        return null;
    }

    @Watch("accountingPeriod")
    setEndDate() {
        this.endDate = "";
        // if (this.accountingPeriod?.end) {
        //     this.endDate = this.accountingPeriod.end;
        // } else {
        //     this.endDate = "";
        // }
    }

    // beforeMount() {
    //     if (this.currentUser) {
    //         const outstanding = this.currentUser?.companyUser?.configuration.outstanding;
    //         if (outstanding) {
    //             if (outstanding.client || outstanding.selectionClient) {
    //                 this.selectedUser = this.currentUser;
    //             }
    //         }
    //     }
    // }

    // openUserDialog() {
    //     if (!this.isAccountingEmployee) {
    //         this.userDialog = true
    //     }
    // }

    // @Apollo({
    //     query: COMPANY_USER,
    //     variables() {
    //         return {
    //             companyId: this.companyId,
    //             userId: this.selectedUser.id,
    //         }
    //     },
    //     skip() {
    //         return !this.companyId || !this.selectedUser?.id
    //     },
    //     specificResult({ data, loading, networkStatus }: any) {
    //         if (!loading) {
    //             if (data && data.companyUsers) {
    //                 if (data.companyUsers.length) {
    //                    this.companyUser = data.companyUsers[0]
    //                    if (this.companyUser.clients) {
    //                        this.userClients = this.companyUser.clients
    //                    } else {
    //                        this.userClients = []
    //                    }
    //                 } else {
    //                     this.companyUser = null
    //                     this.userClients = []
    //                 }
    //             }
    //         }
    //     }
    // })
    // companyUser:any = null

    @Apollo({
        query: COMPANY_USERS,
        variables() {
            return {
                companyId: this.companyId,
            };
        },
        skip() {
            return !this.companyId;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data && data.companyUsers) {
                    if (data.companyUsers.length) {
                        const companyUsers = [];
                        for (const companyUser of data.companyUsers) {
                            if (this.mode === "client") {
                                if (companyUser.clients?.length) {
                                    companyUsers.push(companyUser);
                                } else if (companyUser.configuration?.outstanding?.client) {
                                    companyUsers.push(companyUser);
                                }
                            } else if (this.mode === "supplier") {
                                if (companyUser.configuration?.outstanding?.supplier) {
                                    companyUsers.push(companyUser);
                                }
                            }
                        }

                        if (this.currentUser.id) {
                            this.selectedManager = companyUsers.find(
                                (cu) => cu.user.id === this.currentUser.id,
                            );
                        }
                        this.companyUsers = companyUsers;
                    } else {
                        this.companyUsers = [];
                        this.selectedManager = null;
                    }
                }
            }
        },
    })
    companyUsers: any = [];

    get selectedUserIsAuthorised() {
        if (!this.selectedCompany) {
            return false;
        }
        if (!this.selectedCompany) {
            return false;
        }
        return true;
    }

    //
    // customer companies
    //
    @Apollo({
        query() {
            return this.mode === "client" ? CUSTOMER_COMPANIES : SUPPLIER_COMPANIES;
        },
        variables() {
            return {
                companyId: this.companyId,
            };
        },
        skip() {
            return !this.companyId || !this.isAuthorized;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data) {
                    // console.log(data)
                    if (data.customerCompanies) {
                        this.allThirdPartyCompanies = data.customerCompanies;
                    } else if (data.supplierCompanies) {
                        this.allThirdPartyCompanies = data.supplierCompanies;
                    } else {
                        this.allThirdPartyCompanies = [];
                    }
                }
            }
        },
    })
    allThirdPartyCompanies: Array<any> = [];

    // @Apollo({
    //     query: ACCOUNTING_FIRM_CLIENT_MANAGERS,
    //     variables() {
    //         return {
    //             accountingFirmId: this.companyId,
    //         };
    //     },
    //     debounce: 500,
    //     skip() {
    //         return !this.companyId
    //     },
    //     specificResult({ data, loading, networkStatus }: any) {
    //         if (!loading) {
    //             if (data) {
    //                 if (data.accountingFirmClients) {
    //                     const users = []
    //                     data.accountingFirmClients.forEach(entry => {
    //                         const { id: clientId, client, accountManager } = entry;
    //                         const { id: managerId } = accountManager;

    //                         const userIndex = users.findIndex(user => user.id === managerId)
    //                         if (userIndex < 0) {
    //                             users.push({
    //                                 id: managerId,
    //                                 key: this.getUserDisplayName(accountManager),
    //                                 clients: [client]
    //                             });
    //                         } else {
    //                             users[userIndex].clients.push(client)
    //                         }
    //                     });
    //                     users.sort((a,b) => {
    //                         if (a.key < b.key) return -1
    //                         if (a.key > b.key) return 1
    //                         return 0
    //                     })
    //                     this.accountingFirmClientManagers = users

    //                 } else {
    //                     this.accountingFirmClientManagers = [];
    //                 }
    //             }
    //         }
    //     }
    // })
    // accountingFirmClientManagers: Array<any> = [];

    @Apollo({
        query: THIRDPARTYCOMPANY_TAGS_QUERY,
        variables() {
            return {
                companyId: this.companyId,
                thirdPartyCompanyIds: [],
            };
        },
        skip() {
            return !this.companyId;
        },
        specificResult({ data, loading, networkStatus }: any) {
            this.loading = loading;
            if (!loading && data && data.thirdPartyCompanyTags) {
                const tpcTags = [];
                // tpcTags.push({
                //     id: "",
                //     key: "Sans Etiquette",
                //     thirdPartyCompanies: []
                // });

                data.thirdPartyCompanyTags.forEach((entry) => {
                    const { tag, thirdPartyCompany } = entry;
                    // const { id: tagId, partitionTag } = tag;

                    const tpcTag = tpcTags.find((tpcTag) => tpcTag.id === tag.id);
                    if (!tpcTag) {
                        tpcTags.push({
                            id: tag.id,
                            key: this.tagTitle(entry),
                            thirdPartyCompanies: [thirdPartyCompany],
                        });
                    } else {
                        tpcTag.thirdPartyCompanies.push(thirdPartyCompany);
                    }
                });
                this.thirdPartyCompanyTags = tpcTags;
            } else {
                this.thirdPartyCompanyTags = [];
            }
        },
    })
    thirdPartyCompanyTags: any[] = [];

    @Apollo({
        query: GET_PAYMENT_LINKS,
        variables() {
            return {
                companyId: this.companyId,
                // accountingPeriodId: this.accountingPeriodId,
            };
        },
        skip() {
            debugger;
            return !this.isAuthorized || !this.companyId; //|| !this.outStandingMode; // || !this.accountingPeriodId
        },
        // fetchPolicy: 'network-only',
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data?.getPaymentLinks?.paymentLinks?.length) {
                    this.paymentLinks = data.getPaymentLinks.paymentLinks;
                } else {
                    this.paymentLinks = [];
                }
            }
        },
    })
    paymentLinks = [];

    deletePaymentLinkDialog = false;
    deletePaymentLinkLoading = false;
    paymentLinkToDelete = null;
    openDeletePaymentLinkDialog(paymentLink) {
        this.deletePaymentLinkDialog = true;
        this.paymentLinkToDelete = paymentLink;
    }

    async deletePaymentLink() {
        this.deletePaymentLinkLoading = true;
        await this.$apollo.mutate({
            mutation: DELETE_PAYMENT_LINK,
            variables: {
                id: this.paymentLinkToDelete.id,
            },
        });
        this.deletePaymentLinkLoading = false;
        this.deletePaymentLinkDialog = false;
        this.refresh();
    }

    tagTitle(thirdPartyCompanyTag) {
        let title = "XXX";
        if (thirdPartyCompanyTag.tag) {
            title = thirdPartyCompanyTag.tag.name;
            if (thirdPartyCompanyTag.tag.primaryLog) {
                title +=
                    " - journal " + this.$t("document.type." + thirdPartyCompanyTag.tag.primaryLog);
            }
            if (thirdPartyCompanyTag.tag.partitionTag) {
                title += " - partition " + thirdPartyCompanyTag.tag.partitionTag.name;
            }
        }
        return title;
    }

    statusDico = {
        DONE: "Réglé",
        ACCEPTED: "Réglé",
        ACCEPTED_NO_BANK_STATUS: "Réglé", // deprecated, not used since september 2023
        CREATED: "Envoyé",
    };

    formatStatus(status: string) {
        if (this.statusDico[status]) {
            return this.statusDico[status];
        }
        return status;
    }

    formattedDate(date: string) {
        return moment(date).format("DD/MM/YY");
    }

    newCommonFormatCurrency(amount) {
        return newCommonFormatCurrency(amount);
    }

    get isAuthorized() {
        if (this.mode === "client") {
            return this.currentUser.showOutStandingClient;
        } else if (this.mode === "supplier") {
            return this.currentUser.showOutStandingSupplier;
        }
        return true;
    }

    get thirdPartyCompanies() {
        // debugger;
        // if (this.userClients?.length) {
        //     return this.userClients
        // }

        if (this.mode === "client") {
            if (this.selectedManager?.configuration?.outstanding?.client) {
                return this.allThirdPartyCompanies;
            }
            if (
                this.selectedManager?.configuration?.outstanding?.selectionClient &&
                this.selectedManager?.clients?.length
            ) {
                return this.selectedManager.clients;
            }
            if (
                this.selectedCompany.profile.managementAuthorization &&
                this.selectedCompany.profile.managementAuthorizations?.client
            ) {
                return this.allThirdPartyCompanies;
            }
        } else if (this.mode === "supplier") {
            if (
                this.selectedManager?.configuration?.outstanding?.client ||
                (this.selectedCompany.profile.managementAuthorization &&
                    this.selectedCompany.profile.managementAuthorizations?.supplier)
            ) {
                return this.allThirdPartyCompanies;
            }
        }
        return [];
    }

    get filteredThirdPartyCompanies() {
        let thirdPartyCompanies = this.thirdPartyCompanies;
        let returnNullIfEmpty = true;
        if (this.selectedTagIds.length) {
            returnNullIfEmpty = false;
            const filteredThirdPartyCompanies = [];
            for (const client of thirdPartyCompanies) {
                let addTPC = true;
                for (const tagId of this.selectedTagIds) {
                    const tpcTag = this.thirdPartyCompanyTags.find((tpcTag) => tpcTag.id === tagId);
                    if (tpcTag) {
                        if (!tpcTag.thirdPartyCompanies.find((tpc) => tpc.id === client.id)) {
                            addTPC = false;
                            break;
                        }
                    }
                }
                if (addTPC) {
                    filteredThirdPartyCompanies.push(client);
                }
            }
            thirdPartyCompanies = filteredThirdPartyCompanies;
        }
        if (this.search && thirdPartyCompanies.length) {
            returnNullIfEmpty = false;
            const search = this.search.toLowerCase();
            thirdPartyCompanies = thirdPartyCompanies.filter(
                (c) => c.name?.toLowerCase().indexOf(search) !== -1,
            );
        }
        if (returnNullIfEmpty && !thirdPartyCompanies.length) {
            return null;
        }
        return thirdPartyCompanies;
    }

    refresh() {
        debugger;
        // NOT IMPLEMENTED
    }
}

export default toNative(Outstanding);
</script>
<style></style>
